import { useQuery } from '@hooks/reactQuery';

import { organisationProjects } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getOrganisationProjectsList } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';

import { IItemsResponse } from '@interfaces/common/response';
import { IProjectDTO } from '@interfaces/portal/dto/projectManagementDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { GET_PROJECTS_LIST } from '@constants/queryKeys';

interface IUseQueryOrganisationProjectsReturned {
	isLoadingProjects: boolean;
	countOfRecords: number;
	projectsList: Array<IProjectDTO>;
}

export const useQueryOrganisationProjects = (organizationId?: string): IUseQueryOrganisationProjectsReturned => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		status,
	} = useAppSelector(organisationProjects);

	const {
		data: projectsList,
		isInitialLoading,
		isFetching,
	} = useQuery<IItemsResponse<IProjectDTO>>({
			queryKey: [
				GET_PROJECTS_LIST,
				{
					page,
					pageSize,
					searchValue,
					sortFieldName,
					sortDirection,
					status,
					organizationId,
				},
			],
			queryFn: extractQueryParams(getOrganisationProjectsList),
			enabled: [organizationId],
			allowedRoles: [
				EUserRoles.assetOwnerOrganizationAdministrator,
				EUserRoles.networkOperatorOrganizationAdministrator,
				EUserRoles.assetConsumerOrganizationAdministrator,
			],
			...refetchOptions,
		},
	);

	return {
		isLoadingProjects: isInitialLoading || isFetching,
		projectsList: projectsList?.items || [],
		countOfRecords: projectsList?.count || 0,
	};
};
